import { render, staticRenderFns } from "./onlineStudyDetails.vue?vue&type=template&id=685fd03c&scoped=true&"
import script from "./onlineStudyDetails.vue?vue&type=script&lang=js&"
export * from "./onlineStudyDetails.vue?vue&type=script&lang=js&"
import style0 from "./onlineStudyDetails.vue?vue&type=style&index=0&id=685fd03c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685fd03c",
  null
  
)

export default component.exports